<template>
  <div>
    <div>
      <b-alert v-model="alert.show" :variant="alert.variant" dismissible fade>
        {{alert.message}}
      </b-alert>
      <div v-if="!isMobile() && summary.map_vehicles_logo" style="margin:10px">
        <img :src="summary.map_vehicles_logo" height="100"/>
      </div>
      <div v-else-if="isMobile() && summary.map_vehicles_logo" style="margin:5px">
        <img :src="summary.map_vehicles_logo" width="300"/>
      </div>
      <div v-if="isMobile()" style="margin:5px; font-size: 16px; font-weight: bold" class="d-flex align-items-center justify-content-center">
        Charter ID:&nbsp;&nbsp;<input type="text" v-model="new_filter_value" style="border: 2px solid steelblue; border-radius: 6px; text-align: center; padding: 2px" size="10"/>
        &nbsp;&nbsp;<b-button style="background-color: steelblue; font-weight: bold; font-size: 14px;" v-on:click.prevent="update_filter_value()">Search</b-button>
      </div>
      <div v-else style="margin:20px; font-size: 24px; font-weight: bold" class="d-flex align-items-center justify-content-center">
        Find Vehicles By Charter ID:&nbsp;&nbsp;<input type="text" v-model="new_filter_value" style="border: 2px solid steelblue; border-radius: 6px; text-align: center; padding: 2px" size="10"/>
        &nbsp;&nbsp;<b-button style="background-color: steelblue; font-weight: bold; font-size: 18px;" v-on:click.prevent="update_filter_value()">Search</b-button>
      </div>

      <div ref="test" class="row" style="margin: 0px">
        <div v-if="!isMobile() && items.length > 0" class="col" style="overflow-y:scroll; min-height: 900px; max-height: 900px; max-width: 350px;">
          <div @click="toggle_div(veh, veh.name,'detailsVisible')" v-for="(veh,idx) in items" style="font-size: 20px; text-align: left; padding-top:10px">
            <span v-if="veh.gps.speedMilesPerHour == 0" style="color: darkred; font-size: 20px; font-weight: bold">Bus #{{veh.name | trim(30)}}</span>
            <span v-else style="color: green; font-size: 20px; font-weight: bold">Bus #{{veh.name | trim(25)}}</span>
            <span v-if="veh.driver_name"><br/>&nbsp;&nbsp;{{veh.driver_name}}</span>
            <span v-if="veh.driver_phone"><br/>&nbsp;&nbsp;{{veh.driver_phone | prettyPhoneNumber}}</span>
            <hr/>
          </div>
        </div>
        <div v-if="loading" class="col" style="margin-top: 30px">
          <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
        </div>
        <div v-else-if="items.length > 0 || !filter_value" class="col" style="border: none; padding-right:0px !important; padding-left:0px !important">
          <GmapMap id="map" ref="mapRef"
                   :zoom="zoom"
                   :center="center"
                   :options="mapStyle"
                   style="width:100%;  height: 900px;"
          >
            <GmapMarker
                v-for="(marker,idx) in markers"
                :key="idx"
                :position="marker.position"
                :title="marker.title"
                :label="marker.label"
                :draggable="false"
                :clickable="true"
                :icon="marker.icon"
                @click="openInfoWindowTemplate(marker.bus_name)"
                @mouseover="openInfoWindowTemplate(marker.bus_name)"
                @mouseout="infoWindow.open=false"
            />
            <GmapInfoWindow
                :options="{
                              pixelOffset: { width: 0, height: -65 }
                            }"
                :position="infoWindow.position"
                :opened="infoWindow.open"
            >
              <div v-html="infoWindow.template"></div>
            </GmapInfoWindow>

          </GmapMap>
        </div>
        <div v-else style="padding: 18px; font-size: 20px; font-weight: bold" class="col" >
          <div v-if="filter_value">
            <h3>no vehicles found for Charter ID: {{filter_value}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {get_vehicle_track_fleet} from '../networking/apis'
import {get_vehicle_track_fleet_tbn} from '../networking/tbn_apis'

export default {
  name: 'vehicle_map_by_booking',
  components: {
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      summary: {},
      tenant_id: null,
      filter_mode: 'booking',
      filter_value: null,
      new_filter_value: null,
      items: [],
      items_full: [],
      tenant_type: 'CM',
      loading: false,
      reload_enabled: true,
      follow_enabled: true,
      center: null,
      zoom: null,
      markers: [],
      markers_full: [],
      reload_interval: 60000,
      reload_center: null,
      bounds: null,
      timer: null,
      reload_inflight: false,
      selected_route_name: '',
      route_name_options: [],
      infoWindow: {
        position: {lat: 0, lng: 0},
        open: false,
        template: ''
      },
      mapStyle: {
        styles: [
          {
            "featureType": "landscape",
            "stylers": [
              { "color": "#F3F4F9" }
            ]
          },          {
            "featureType": "water",
            "stylers": [
              { "color": "#C1CDE4" }
            ]
          },
          {
            "featureType": "landscape.natural.terrain",
            "stylers": [
              { "color": "#E0EDCA" }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{color: '#DDDDDD'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [{color: '#FFFFFF'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [{color: '#FEF8D6'}]
          },
          {
            featureType: 'transit',
            stylers: [{"visibility": "off"}]
          },
          {
            featureType: 'poi',
            stylers: [{"visibility": "off"}]
          },
        ]
      }
    }
  },
  async created() {
    this.check_features()
  },  beforeDestroy() {
    this.stopTimer()
  },
  async mounted () {
    this.stopTimer()
  },
  methods: {
    startTimer() {
      this.stopTimer()
      if (this.items && this.items.length > 0 && this.filter_value) {
        this.timer = setInterval(() => this.reload_data(), this.reload_interval)
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    async resetTimerAndReload() {
      this.stopTimer()
      await this.reload_data()
      this.startTimer()
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    async check_features() {

      this.tenant_id = this.$route.path.split('/booking-track/')[1].split("/")[0]
      if (this.$route.path.split('/booking-track/')[1].split("/").length > 1) {
        this.filter_value = this.$route.path.split('/booking-track/')[1].split("/")[1]
        this.new_filter_value = this.filter_value
      }
      if (this.$route.query.type)
        this.tenant_type = this.$route.query.type

      this.load_data()
    },
    openInfoWindowTemplate(selected_name) {
      const loc = this.items.filter(item => item.name == selected_name)[0]

      if (loc != null) {
        const position = {
          lat: Number(loc.gps.latitude),
          lng: Number(loc.gps.longitude),
        };
        this.infoWindow.position = position
        this.infoWindow.template = loc.marker_html
        this.infoWindow.open = true
      }
    },
    toggle_div(item,selected_name,field) {
      // item[field] = !item[field];
      // this.$forceUpdate();

      const loc = this.items.filter(item => item.name == selected_name)[0]
      if (loc != null) {
        this.center = {
          lat: Number(loc.gps.latitude),
          lng: Number(loc.gps.longitude),
        };
        this.zoom = 13
      }
    },
    async update_filter_value() {
      if (this.timer)
        this.stopTimer()
      this.loading = true
      this.filter_value = this.new_filter_value
      this.load_data();
    },
    async load_data() {
      this.loading = true
      try {
        let results = null;

        if (this.tenant_type=='CM')
          results = await get_vehicle_track_fleet(this.tenant_id,this.filter_mode,this.filter_value)
        else
          results = await get_vehicle_track_fleet_tbn(this.tenant_id,this.filter_mode,this.filter_value)

        const {value: { data = [] } } = results

        this.summary = data.summary
        this.route_name_options = data.summary.route_names
        this.items = data.results
        this.items_full = data.results
        this.markers = []

        if (this.items && this.items.length == 0) {
          let position = {
            lat: Number('39.917742615494085'),
            lng: Number('-97.13906071185122'),
          };
          this.zoom = 5

          if (this.summary.yards && this.summary.yards.length > 0) {
            const yard = this.summary.yards[0];
            position = {
              lat: Number(yard['lat']),
              lng: Number(yard['lon'])
            }
            this.zoom = 7
          }
          this.center = position;
          this.loading = false;
        } else {
          this.zoom = this.summary.zoom

          if (this.items && this.items.length > 0) {
            let idx = 0
            for (const loc of this.items) {
              idx += 1
              const position = {
                lat: Number(loc.gps.latitude),
                lng: Number(loc.gps.longitude),
              };
              this.center = position;
              this.reload_center = position;

              let marker_title = "Vehicle #" + loc.name
              if (loc.route_name != null) {
                marker_title += " - " + loc.route_name;
              }

              if (loc.pickup_address) {
                const pickup_position = {
                  lat: Number(loc.pickup_lat),
                  lng: Number(loc.pickup_lon),
                };
                this.markers.push({position: pickup_position, title: 'pickup', label: {text: loc.pickup_address, className: 'addr-label-' + idx}, icon: this.mapSymbol("green")});
              }

              if (loc.destination_address) {
                const destination_position = {
                  lat: Number(loc.destination_lat),
                  lng: Number(loc.destination_lon),
                };
                this.markers.push({position: destination_position, title: 'destination', label: {text: loc.destination_address, className: 'addr-label-' + idx}, icon: this.mapSymbol("orange")});
              }

              if (loc.dropoff_address && (loc.dropoff_lat != loc.pickup_lat && loc.dropoff_lon != loc.pickup_lon)) {
                const pickup_position = {
                  lat: Number(loc.dropoff_lat),
                  lng: Number(loc.dropoff_lon),
                };
                this.markers.push({position: pickup_position, title: 'dropoff', label: {text: loc.dropoff_address, className: 'addr-label-' + idx}, icon: this.mapSymbol("red")});
              }

              if (loc.eta)
                marker_title += " (" + loc.eta + ")"

              this.markers.push({
                position: position,
                heading: loc.gps.headingDegrees,
                title: marker_title,
                bus_name: loc.name,
                route_name: loc.route_name,
                label: {text: marker_title, className: 'tracking-label'},
                icon: this.arrowSymbol(loc.gps)
              });

            }
          }

          this.zoom = 10
          this.markers_full = this.markers
          this.loading = false

          if (this.markers.length > 1)
            this.fitMapToMarkers()
        }

        this.stopTimer()
        if (this.items && this.items.length > 0 && this.filter_value)
          this.startTimer()
      } catch(e) {
        this.alert = {show: true, message: "error retrieving data, try again later or contact support if needed" + e, variant: 'danger'}
      }
    },
    async fitMapToMarkers() {
      if (!this.$refs.mapRef) {
        let cnt=0;
        while(cnt<10) {
          if (this.$refs.mapRef)
            break;
          await this.sleep(500);
          console.log("waiting for mapref: " + cnt)
          cnt++;
        }
      }

      this.bounds = new google.maps.LatLngBounds();
      for (const marker of this.markers)
        this.bounds.extend(marker.position);

      this.$refs.mapRef.$mapObject.fitBounds(this.bounds);
    },
    async reload_data() {
      try {
        if (!this.reload_enabled) {
          console.log("reload disabled")
          return
        }
        if (this.$pageVisibility && this.$pageVisibility.hidden) {
          return
        }
        if (this.reload_inflight) {
          return
        }
        this.reload_inflight = true

        let results = null;

        if (this.tenant_type=='CM')
          results = await get_vehicle_track_fleet(this.tenant_id,this.filter_mode,this.filter_value)
        else
          results = await get_vehicle_track_fleet_tbn(this.tenant_id,this.filter_mode,this.filter_value)

        const {value: { data = [] } } = results

        this.summary = data.summary
        this.items = data.results
        this.items_full = data.results
        this.route_name_options = data.summary.route_names

        if (this.items.length == 0) {
          this.reload_inflight = false
          return;
        }

        this.filter_items()
        if (this.items && this.items.length > 0) {
          let idx = 0
          for (const loc of this.items) {
            idx += 1
            const position = {
              lat: Number(loc.gps.latitude),
              lng: Number(loc.gps.longitude),
            };

            let current_marker_idx = this.markers.findIndex(x => x.bus_name === loc.name);
            let pickup_idx = this.markers.findIndex(x => x.title === 'pickup');
            let destination_idx = this.markers.findIndex(x => x.title === 'destination');
            let dropoff_idx = this.markers.findIndex(x => x.title === 'dropoff');

            let marker_title = "Vehicle #" + loc.name;
              if (loc.route_name != null)
                marker_title += " - " + loc.route_name;

            if (loc.eta)
              marker_title += " (" + loc.eta + ")"

            if (pickup_idx != -1) {
              this.markers[pickup_idx].label = {text: loc.pickup_address, className: 'addr-label-' + idx};
              this.markers[destination_idx].label = {text: loc.destination_address, className: 'addr-label-' + idx};
              this.markers[dropoff_idx].label = {text: loc.dropoff_address, className: 'addr-label-' + idx};
            }

            if (current_marker_idx == -1) {
              this.markers.push({position: position, heading: loc.gps.headingDegrees, title: marker_title, bus_name: loc.name, route_name: loc.route_name, label: {text: marker_title, className: 'tracking-label'}, icon: this.arrowSymbol(loc.gps)});
              current_marker_idx = this.markers.findIndex(x => x.bus_name === loc.name);
            } else {
              if (marker_title != this.markers[current_marker_idx].title) {
                this.markers[current_marker_idx].label = {text: marker_title, className: 'tracking-label'};
              }
            }

            this.animatedMove(this.markers[current_marker_idx], loc.gps);
          }
        }

        let markers_to_remove = []
        for (const old_marker of this.markers) {
          let marker_idx = this.items.findIndex(x => x.name === old_marker.bus_name);
          if (marker_idx == -1)
            markers_to_remove.push(old_marker.bus_name);
        }
        if (markers_to_remove.length > 0) {
          console.log("markers_to_remove:" + markers_to_remove);
          this.markers = this.markers.filter(item => !markers_to_remove.includes(item.bus_name))
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      } finally {
        this.reload_inflight = false
      }

    },
    animatedMove(marker, new_loc) {

      const new_position = {
        lat: Number(new_loc.latitude),
        lng: Number(new_loc.longitude),
      };

      let new_heading = Number(new_loc.headingDegrees);
      let old_heading = marker.icon.rotation;

      //console.log("heading change: old = " + old_heading + ", new = " + new_heading);

      if (new_heading == 0)
        new_heading = marker.icon.rotation;
      if (old_heading == 0 || isNaN(old_heading))
        marker.icon.rotation = new_heading;

      marker.speed = new_loc.speedMilesPerHour;

      var delta_incr = 100;

      var deltalat = (new_position.lat - marker.position.lat) / delta_incr;
      var deltalng = (new_position.lng - marker.position.lng) / delta_incr;
      var deltaheading = (new_heading - marker.icon.rotation) / delta_incr;

      var direction = 'clockwise';
      if (new_heading > old_heading) {
        if ((new_heading - old_heading) > 180) {
          direction = 'counterclockwise';
          deltaheading = (old_heading + (360-new_heading)) / delta_incr;
        } else {
          deltaheading = (new_heading - old_heading) / delta_incr;
        }
      } else if (old_heading > new_heading) {
        if ((old_heading - new_heading) > 180) {
          deltaheading = (new_heading + (360-old_heading)) / delta_incr;
        } else {
          deltaheading = (old_heading - new_heading) / delta_incr;
          direction = 'counterclockwise';
        }
      }

      if (Math.abs(old_heading - new_heading) < 2)
        deltaheading = 0;

      //console.log("direction: " + direction + ":" + Math.round(deltaheading * delta_incr));

      var delay = this.reload_interval/delta_incr;

      //console.log("heading adjust: old = " + Number(old_heading) + ", new = " + Number(new_heading) + ", deltas: lat " + deltalat + ", lon " + deltalng + ", heading: " + deltaheading + ", delay: " + delay);

      for (var i = 0; i < delta_incr; i++) {
        (function(ind) {
          setTimeout(
              function() {
                let incr_position = {
                  lat: (marker.position.lat + deltalat),
                  lng: (marker.position.lng + deltalng),
                };
                marker.position = incr_position;

                if (deltaheading != 0) {
                  if (direction == 'clockwise')
                    marker.icon.rotation = Number(marker.icon.rotation + deltaheading);
                  else
                    marker.icon.rotation = Number(marker.icon.rotation - deltaheading);

                  if (marker.icon.rotation > 360) {
                    //console.log("resetting >360 to 0");
                    marker.icon.rotation = 0;
                  }

                  if (Math.floor(marker.icon.rotation) != (Math.floor(marker.icon.rotation + deltaheading))) {
                    //console.log("-->rotating: " + marker.icon.rotation)
                    marker.icon =
                        {
                          path: (new_loc.speedMilesPerHour == 0 || new_heading == 0) ? "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0" : "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
                          scale: 1.5,
                          strokeColor: "white",
                          strokeStyle: "bold",
                          fillColor: new_loc.speedMilesPerHour == 0 ? "darkred" : "#29C68A",
                          fillOpacity: .6,
                          rotation: marker.icon.rotation
                        }
                  }
                }
              }, delay * ind
          );
        })(i)
      }
    },
    mapSymbol(color) {
      return {
        path: "M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
        fillColor: color,
        fillOpacity: 0.6,
        strokeWeight: 0,
        rotation: 0,
        scale: 1.5,
      }
    },
    arrowSymbol(loc) {
      return {
        path: (loc.speedMilesPerHour == 0 || loc.headingDegrees == 0) ? "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0" : "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
        scale: 1.5,
        strokeColor: "white",
        strokeStyle: "bold",
        fillColor: loc.speedMilesPerHour == 0 ? "darkred" : "#29C68A",
        fillOpacity: 1,
        rotation: Number(loc.headingDegrees)
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    filter_items() {
      this.items = this.items_full
      this.markers_new = this.markers_full
      if (this.selected_route_name != '') {
        this.items = this.items.filter(item => this.contains(item.route_name, this.selected_route_name))
        this.markers_new = this.markers_new.filter(item => this.contains(item.route_name, this.selected_route_name))
      }
      this.markers = this.markers_new
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    }
  },
  computed:{
  },
  watch: {
    selected_route_name(val) {
      this.filter_items()
    },
    '$pageVisibility.hidden'(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.resetTimerAndReload()
      }
    }
  }
}
</script>
<style scope>

.tracking-label {
  opacity: 0.8;
  font-size: 12px;
  bottom: 35px;
  position: relative;
  border: 1px solid black;
  background-color: #333;
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}

.addr-label {
  opacity: 0.8;
  font-size: 12px;
  bottom: -45px;
  position: relative;
  border: 1px solid black;
  background-color: steelblue;
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}
.addr-label-1 {
  opacity: 0.8;
  font-size: 12px;
  bottom: -45px;
  position: relative;
  border: 1px solid black;
  background-color: steelblue;
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}
.addr-label-2 {
  opacity: 0.8;
  font-size: 12px;
  bottom: -68px;
  position: relative;
  border: 1px solid black;
  background-color: steelblue;
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}

</style>